function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';
import OpenableComponent from '../OpenableComponent';
import { classNamesFor } from '../utils/classNames';
import FocusTrap from '../FocusTrap';
import ClickAway from '../ClickAway';
var cx;
/**
 * The AssistPanel component is a modal layered UI. It is used to present
 *
 * additional information over the main page. It is designed to work with
 * @sie/web-common-layers and the UiLayers component.
 *
 * - [DIG20 ATLAS spec](https://atlas.np.tools.playstation.net/design/b8db4421-94cf-4195-b32e-769531047c56)
 */

var AssistPanel = /*#__PURE__*/function (_OpenableComponent) {
  _inherits(AssistPanel, _OpenableComponent);

  var _super = _createSuper(AssistPanel);

  function AssistPanel() {
    var _this;

    _classCallCheck(this, AssistPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onClickAway", function (event) {
      event.stopPropagation();

      _this.close();
    });

    return _this;
  }

  _createClass(AssistPanel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var openOnMount = this.props.openOnMount;

      if (openOnMount) {
        // without the timeout the transition does not run
        setTimeout(function () {
          return _this2.open();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          closeLabel = _this$props.closeLabel,
          footer = _this$props.footer,
          qa = _this$props.qa,
          title = _this$props.title,
          trackClick = _this$props.trackClick;
      var isOpen = this.isOpen();

      var _AssistPanel$getClass = AssistPanel.getClassName({
        className: className,
        isOpen: isOpen
      }),
          root = _AssistPanel$getClass.root,
          paneClass = _AssistPanel$getClass.pane,
          closeButtonClass = _AssistPanel$getClass.closeButton,
          headerClass = _AssistPanel$getClass.header,
          contentClass = _AssistPanel$getClass.content,
          footerClass = _AssistPanel$getClass.footer;

      return /*#__PURE__*/React.createElement(FocusTrap, {
        className: root,
        "data-qa": qa,
        onEscape: this.close,
        trap: isOpen,
        includeWrapper: true
      }, /*#__PURE__*/React.createElement(ClickAway, {
        as: "aside",
        onClickAway: this.onClickAway,
        className: paneClass
      }, /*#__PURE__*/React.createElement("div", {
        className: closeButtonClass
      }, /*#__PURE__*/React.createElement(Button, {
        ariaLabel: closeLabel,
        iconOnly: true,
        onClick: this.close,
        qa: "".concat(qa, "#close"),
        size: "medium",
        trackClick: trackClick,
        variant: "quick-action"
      }, /*#__PURE__*/React.createElement(Icon, {
        type: "close"
      }))), /*#__PURE__*/React.createElement("header", {
        className: headerClass
      }, title), /*#__PURE__*/React.createElement("section", {
        className: contentClass
      }, children), !!footer && /*#__PURE__*/React.createElement("footer", {
        className: footerClass
      }, footer)));
    }
  }]);

  return AssistPanel;
}(OpenableComponent);

AssistPanel.getClassName = function (_ref) {
  var className = _ref.className,
      isOpen = _ref.isOpen;
  return {
    root: cx('psw-assist-panel', 'psw-l-full-screen', isOpen && 'psw-pointer-events-on', 'psw-m-t-9', 'psw-l-stack-bottom', isOpen && 'psw-is-open', className),
    pane: cx('psw-assist-panel-pane', 'psw-c-bg-2', 'psw-fill-x', 'psw-l-anchor', 'psw-l-stack-left', 'psw-r-top-4'),
    closeButton: cx('psw-assist-panel-close', 'psw-c-bg-2', 'psw-l-anchor-top-right', 'psw-l-center-right', 'psw-m-sub-x-gm', 'psw-r-pill', 'psw-l-line-left'),
    header: cx('psw-assist-panel-header', 'psw-p-t-6', 'psw-p-b-5', 'psw-t-title-m', 'psw-l-section', 'psw-m-y-0', 'psw-l-line-center'),
    content: cx('psw-assist-panel-content', 'psw-fill-x', 'psw-p-t-3', 'psw-p-b-5', 'psw-scroll-y', 'psw-fill-y'),
    footer: cx('psw-b-t-divider', 'psw-c-b-support', 'psw-assist-panel-footer', 'psw-c-bg-1', 'psw-fill-x', 'psw-l-stack-center', 'psw-p-7', 'psw-l-space-y-3')
  };
};

AssistPanel.defaultProps = {
  children: null,
  className: '',
  closeLabel: '',
  footer: null,
  isOpen: null,
  closeDelay: 300,
  onClose: function onClose() {},
  onOpen: function onOpen() {},
  openOnMount: null,
  qa: '',
  title: '',
  trackClick: null
};
AssistPanel.propTypes = {
  /**
   * AssistPanel content
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.arrayOf(PropTypes.any)]),

  /**
   * Add custom classes to the AssistPanel
   */
  className: PropTypes.string,

  /**
   * Value to use for close button aria-label
   */
  closeLabel: PropTypes.string,

  /**
   * Optional footer content
   */
  footer: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),

  /**
   * If set to null the state will be managed internally. If a boolean is passed
   * the overlay will be controlled
   */
  isOpen: PropTypes.bool,

  /**
    * Event callback called when the AssistPanel is closed
    */
  onClose: PropTypes.func,

  /**
   * Event callback called when the AssistPanel is opened
   */
  onOpen: PropTypes.func,

  /**
   * Whether or not the panel should be opened immediately upon mounting
   */
  openOnMount: PropTypes.bool,

  /**
   * The qa selector to set for the instance of the component
   */
  qa: PropTypes.string,

  /**
   * The title of the AssistPanel
   */
  title: PropTypes.string,

  /**
   * The telemetry event to track
   */
  trackClick: PropTypes.string
};
cx = classNamesFor(AssistPanel);
export default AssistPanel;